import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Crawl Baby Crawl';
const DEFAULT_IMAGE = 'https://urban-crawl-fest.preview.emergentagent.com/api/files/crawlbabycrawl/uploads/f5033268-94d0-40a0-8768-633d93fb16c7.jpg';
const BASE_URL = 'https://crawlbabycrawl.com';

const MetaTags = ({ title, description, image, path = '/' }) => {
  const fullUrl = `${BASE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{`${title} | ${SITE_NAME}`}</title>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default MetaTags;
